import { Tag, Tooltip } from 'antd';
import React from 'react';

const FONT_SIZE = { small: 11, large: 12 };

/**
 * Ligne de tags : jusqu’à `maxVisible` libellés, ellipsis, "+N" avec tooltip (même logique que la carte média).
 */
const MediaTagsInline = ({ tags, maxVisible = 2, size = 'small' }) => {
  const fontSize = FONT_SIZE[size] ?? FONT_SIZE.small;
  const visibleTags = tags.slice(0, maxVisible);
  const hiddenCount = Math.max(0, tags.length - maxVisible);
  const hiddenTagNames = tags.slice(maxVisible).join(', ');

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'flex-start',
        gap: 4,
        alignItems: 'center',
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      {visibleTags.map((tag) => (
        <Tag
          key={tag}
          style={{
            margin: 0,
            flex: '0 1 auto',
            minWidth: 0,
            maxWidth: maxVisible === 1 ? '100%' : undefined,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize,
          }}
        >
          <span
            style={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              minWidth: 0,
              maxWidth: '100%',
            }}
          >
            {tag}
          </span>
        </Tag>
      ))}
      {hiddenCount > 0 && (
        <Tooltip title={hiddenTagNames}>
          <Tag
            style={{
              margin: 0,
              flexShrink: 0,
              fontSize,
              cursor: 'default',
            }}
          >
            +{hiddenCount}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
};

export default React.memo(MediaTagsInline);
